import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './api/index'
import './tools/index'
import '../theme/index.css'
import Element from 'element-ui'
import './assets/css/reset.css'
import './assets/font/iconfont.css'
import  plugin from './plugin/index'
import VueCropper from 'vue-cropper'

Vue.use(Element)
Vue.use(plugin)
Vue.use(VueCropper)
Vue.config.productionTip = false

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default vue


